
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { IUserState } from '../../store/contract';

@Component
export default class OffcanvasMenu extends Vue {
    @State('user') userState: IUserState;

    get skilldUrl() {
        return this.$store.state.root && this.$store.state.root._links.skilld.href;
    }

    get capplanUrl() {
        return this.$store.state.root && this.$store.state.root._links.capplan.href;
    }

    public openFeedbackService() {
      const title = "Feedback AE Tooling";
      window.open(`https://aewiki.atlassian.net/servicedesk/customer/portal/47/group/135/create/581?summary=${title}`, "_blank");
    }
}
